export function getModelApiPath(appName, modelName) {
  // TODO: This is a temporary workaround to handle the special case of annotation types, which have a different API path than other models. We should refactor this in the future to have a more consistent API structure.
  if (appName === 'annotations' && modelName === 'annotationtypes') {
    return 'annotationtypes'
  }
  return `${appName}/${modelName}`
}

export function getModelApiBaseUrl(appName, modelName) {
  return `${getModelApiPath(appName, modelName)}/`
}
